import { CommunityPostTopic } from '@/types/models/communities';

export default {
  en: {
    feed: {
      newPosts: 'New posts',
    },
    topicsHeader: 'Post topics',
    signalsHeader: 'Community signals',
    createPost: {
      createPost: 'Create post',
      startPost: 'Start a new post',
      post: 'Post',
      title: 'Title',
      description: 'Description',
      selectTopic: 'Select topic',
      requiredField: 'Please enter a value',
      cancel: 'Cancel',
      characters: '{count} / {max} characters',
      postSuccess: 'Post created successfully',
      postError: 'Error creating post. Try again',
      discussInCommunity: 'Create post',
      visibleTo: 'Post will be visible to all members of',
      privacyTooltip: 'Please consider this if you are sharing sensitive information.',
    },
    associatedData: {
      supplier: {
        yourReview: 'Your review',
        othersReview: "{orgName}'s review",
        viewProfile: 'View profile',
        leftCommunity:
          "Author's review on the supplier is unavailable as the organisation has left the community.",
        authorNotConnected:
          "Author's review on this supplier is unavailable as they are no longer connected to them.",
        youNotConnected: 'Your organisation is not connected to this supplier.',
      },
    },
    postContent: {
      readMore: 'read more',
      postAReply: 'Post a reply',
      replies: '{count} reply | {count} replies',
      newReplies: '{n} new',
      edited: 'edited',
      editedLong: 'Last edited at {date}',
    },
    postPage: {
      back: 'Back',
      fetchError: 'Unable to load post. Refresh the page to try again.',
      actions: 'Actions',
      editPost: 'Edit post',
      editReply: 'Edit',
      delete: 'Delete',
    },
    editPostModal: {
      title: 'Editing post',
      cta: 'Save edits',
    },
    deletePostModal: {
      title: 'Deleting post',
      description: 'Are you sure you want to delete this post? All replies will be deleted too.',
      cta: 'Yes, delete',
      success: 'Post deleted!',
      failure: 'Failed to delete post',
    },
    editReplyModal: {
      title: 'Editing reply',
      cta: 'Save edits',
      postError: 'Error editing post. Try again',
    },
    deleteReplyModal: {
      title: 'Deleting reply',
      description: 'Are you sure you want to delete this reply?',
      cta: 'Yes, delete',
      success: 'Reply deleted!',
      failure: 'Failed to delete reply',
    },
    postUpvote: {
      upvote: 'Upvote post',
      unupvote: 'Remove upvote',
    },
    replyContent: 'Start a reply...',
    replyButton: 'Reply',
    replyCancel: 'Cancel',
    replySuccess: 'Replied to post successfully',
    network: 'Network map',
    topics: {
      [CommunityPostTopic.General]: 'General',
      [CommunityPostTopic.Suppliers]: 'Suppliers',
      [CommunityPostTopic.IndustryChat]: 'Industry chat',
      [CommunityPostTopic.BestPractices]: 'Best practices',
      [CommunityPostTopic.EmergingThreats]: 'Emerging Threats',
      [CommunityPostTopic.Events]: 'Events',
      [CommunityPostTopic.Activity]: 'New suppliers',
    } satisfies Record<CommunityPostTopic, string>,
    topicFilters: {
      allPosts: 'All posts',
    },
    activity: {
      memberAdded: '{memberName} joined the community',
      memberAddedGroup: '{newMembers} {joinedCommunity}',
      newMembers: '{n} new members',
      joinedCommunity: 'joined the community',
      connectionCreated: '{memberName} connected to {supplierName}',
      connectionCreatedGroup: '{memberName} connected to {newSuppliers}',
      newSuppliers: '{n} new suppliers',
    },
  },
};
